var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"app":"","temporary":"","value":_vm.value,"color":"tertiary","right":"","width":"400px"},on:{"input":_vm.onInput}},[(_vm.value)?_c('v-change-log',{attrs:{"path":_vm.path,"recursive":_vm.recursive}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }